<template>
  <fieldset class="u-mb-0">
    <legend>
      Filter Search Results
    </legend>

    <div class="form-group u-mb-sm">
      <input
        id="images_filter_all"
        v-model="filtertype"
        name="images_filter"
        class="images_filter_option"
        type="radio"
        value="all"
      >
      <label for="images_filter_all">
        <span
          v-if="filtertype == 'all'"
          class="u-weight-bold"
        >
          All images
        </span>
        <span v-else>All images</span>
      </label>

      <input
        id="images_filter_sightings"
        v-model="filtertype"
        name="images_filter"
        class="images_filter_option"
        type="radio"
        value="sightings"
      >
      <label for="images_filter_sightings">
        <span
          v-if="filtertype == 'sightings'"
          class="u-weight-bold"
        >
          Images with sightings
        </span>
        <span v-else>Images with sightings</span>
      </label>

      <input
        id="images_filter_hashonly"
        v-model="filtertype"
        name="images_filter"
        class="images_filter_option"
        type="radio"
        value="hashonly"
      >
      <label for="images_filter_hashonly">
        <span
          v-if="filtertype == 'hashonly'"
          class="u-weight-bold"
        >
          Images without sightings (hash only)
        </span>
        <span v-else>Images without sightings (hash only)</span>
      </label>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'ImageSearchFilterResults',
  props: {},
  data() {
    return {
      filtertype: 'all'
    }
  },
  watch: {
    filtertype: {
      immediate: true,
      handler(newVal, oldVal) {
        if (oldVal !== undefined) {
          this.$emit('filterTrigger', newVal)
        }
      }
    }
  }
}
</script>
